// frontend/helpers/validateListCutterJobName.js

/**
 * Validates a list cutter job name with the server
 * 
 * @param {string} name - The job name to validate
 * @param {string|null} originalName - The original name (if updating an existing job)
 * @returns {Promise<Object>} - Object containing {isValid, errorMessage}
 */
export const validateListCutterJobName = async (name, originalName = null) => {
    // Check for empty name
    if (!name || !name.trim()) {
      return {
        isValid: false,
        errorMessage: 'Job name cannot be empty'
      };
    }
  
    // If the name hasn't changed from the original, it's valid
    if (originalName && name === originalName) {
      return {
        isValid: true,
        errorMessage: null
      };
    }
  
    try {
      // Call the API to check if the name is already taken
      const response = await fetch(`/list-cutter/api/jobs/validate_name/?name=${encodeURIComponent(name)}`);
      const data = await response.json();
      
      return {
        isValid: data.valid,
        errorMessage: data.valid ? null : (data.error || 'This name is already in use')
      };
    } catch (error) {
      return {
        isValid: false,
        errorMessage: 'Error checking name availability'
      };
    }
  };